import { Box } from '@mui/material'
import React from 'react'
import { CommonHeading } from '../Common'

const PageHeading = ({title}) => {
  return (
    <>
      <Box sx={{
        // padding:'70px 0 90px',
        position: 'relative',
        backgroundRepeat: 'no-repeat',
        height: {sm:'400px',xs:'300px'},
        position: 'relative',
        // zIndex: '1',
        '&::before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          zIndex: '1',
          backgroundColor: '#000000c7',
          top: '0'
        }

      }}>

        <img src='/images/Page-Heading/breadcrumb-image.jpg' style={{ objectFit: 'cover', height: '100%', width: '100%' }} />
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',zIndex:'1 ' }}>
          <CommonHeading text={title} margin={'50px 0 0 0'} />
        </Box>
      </Box>
    </>
  )
}

export default PageHeading